import { defineMessages } from 'react-intl';

export default defineMessages({
  color: {
    id: 'VariantSelection.title',
    description: 'Title for the color selector',
    defaultMessage: 'Color: ',
  },
  variantPriceDiff: {
    id: 'VariantSelection.variantPriceDiff',
    description: 'Variant Price Difference',
    defaultMessage: '+{price}',
  },
  variantSavings: {
    id: 'VariantSelection.variantSavings',
    description: 'Variant Savings',
    defaultMessage: 'Save {price}',
  },
  variantSavingsPercentOff: {
    id: 'VariantSelection.variantSavingsPercentOff',
    description: 'Variant Savings Percent Off',
    defaultMessage: 'Save {percent}%'
  },
  PurpleRestoreMattressSofter: {
    id: 'VariantSelection.PurpleRestoreMattressSofter',
    description: 'Purple Restore softer description',
    defaultMessage: 'Medium-Soft — very slight bounce with body-conforming, all-over pressure relief.',
  },
  PurpleRestoreMattressFirmer: {
    id: 'VariantSelection.PurpleRestoreMattressFirmer',
    description: 'Purple Restore firmer description',
    defaultMessage: 'Supportive yet relaxed Firm feel, less yielding than Restore™ Soft, with excellent pressure relief.',
  },
  PurpleRestorePlusMattressSofter: {
    id: 'VariantSelection.PurpleRestorePlusMattressSofter',
    description: 'Purple RestorePlus softer description',
    defaultMessage: 'Medium-Soft feel —yielding, body-conforming top with flexible pushback from zoned coils.',
  },
  PurpleRestorePlusMattressFirmer: {
    id: 'VariantSelection.PurpleRestorePlusMattressFirmer',
    description: 'Purple RestorePlus firmer description',
    defaultMessage: 'Medium-Firm feel — taut, bouncy top with a less body-conforming feel.',
  },
  PurpleRestorePremierMattressSofter: {
    id: 'VariantSelection.PurpleRestorePremierMattressSofter',
    description: 'Purple RestorePremier softer description',
    defaultMessage: 'Balanced, Soft feel – just the right amount of support and deep, conforming comfort.',
  },
  PurpleRestorePremierMattressFirmer: {
    id: 'VariantSelection.PurpleRestorePremierMattressFirmer',
    description: 'Purple RestorePremier firmer description',
    defaultMessage: 'Medium-Firm feel — airy, lightly conforming relief with support that provides slight bounce-back.',
  },

});
